module.exports = __webpack_public_path__ + "img/erweima.0ee2b2ad.png";